/* DeleteAction.js */

"use strict";

const DEVICE_NAME_MAX_LENGTH = 60;
const WARNING_CONTROLLED = "Sorry! Devices assigned to a controller device cannot be deleted.\n";
const WARNING_DEVICE =
    "Deleting a device also deletes the device's configuration snapshots, logs, and OS plan results.\n\n";
const WARNING_CONTROLLER =
    "Deleting a controller also deletes its controlled devices, their configuration snapshots, logs, and OS plan results.\n\n";
class DeleteAction {
    constructor(logger, gameEditor, modalUserFeedback, DeviceEntity) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._modalUserFeedback = modalUserFeedback;
        this._DeviceEntity = DeviceEntity;
        this.doTheThang = this.doTheThang.bind(this);
    }

    run() {
        let {
            name: deviceName,
            controlType,
            baseControlType,
            controllerId,
        } = this._gameEditor.getDevice();

        let shortDeviceName =
            deviceName.length > DEVICE_NAME_MAX_LENGTH
                ? deviceName.substring(0, DEVICE_NAME_MAX_LENGTH) + "…"
                : deviceName;

        let message = "";
        let confirmDetails = {
                text: "Confirm",
                type: "destructive",
            },
            rejectDetails = {
                text: "Cancel",
                type: "text",
            };

        if (
            (baseControlType === "CONTROLLED" || baseControlType === "HYBRID_CONTROLLED") &&
            controllerId
        ) {
            message += WARNING_CONTROLLED;
            confirmDetails = {
                text: "OK",
                type: "destructive",
                classes: "hidden",
            };
            rejectDetails = {
                text: "OK",
                type: "text",
            };
        } else if (baseControlType === "CONTROLLER" || baseControlType === "HYBRID_CONTROLLER") {
            message += WARNING_CONTROLLER;
            message += "Are you sure you want to delete the device?\n\n" + shortDeviceName + "\n";
        } else if (controlType) {
            message += WARNING_DEVICE;
            message += "Are you sure you want to delete the device?\n\n" + shortDeviceName + "\n";
        }

        return this._gameEditor
            .runQuickConfirmationActionWorkflow(
                {
                    message: message,
                    title: "Delete",
                    confirmDetails,
                    rejectDetails,
                },
                this.doTheThang
            )
            .finally(() => {
                if (this._gameEditor.currentEntityRemoved) {
                    this._gameEditor.currentEntityRemoved = false;
                    this._gameEditor.currentEntityDeleteInProgress = false;
                    this._gameEditor.closeEditor(this._gameEditor.editorTabStateId, true);
                }
            });
    }

    doTheThang() {
        const device = this._gameEditor.getDevice();
        const showProgFunc = (prog) => {
            this._modalUserFeedback.showLoadingProgress(
                `${prog.successCount} of ${prog.targetCount}`
            );
        };
        return device
            .runDeleteDeviceWork({launchAndForget: false}, showProgFunc)
            .then((workResults) => {
                this._DeviceEntity.throwWorkErrors(workResults);
            })
            .catch((err) => {
                this._logger.warn({error: err}, "DeleteAction.run() - Error");
                this._gameEditor.currentEntityDeleteInProgress = false;
                return Promise.reject(err);
            });
    }
}

module.exports = DeleteAction;

DeleteAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "$teve.entities.Device",
];

DeleteAction.$displayDetails = {
    type: "Action",
    name: "DeleteAction",
    icon: "common.trash_bin",
    title: "Delete device",
    shown: true,
    order: 4,
};
